// extracted by mini-css-extract-plugin
export var image = "_iw-0";